import { render, staticRenderFns } from "./BuddleOrderDetail.vue?vue&type=template&id=2d2da57d&scoped=true"
import script from "./BuddleOrderDetail.vue?vue&type=script&lang=js"
export * from "./BuddleOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./BuddleOrderDetail.vue?vue&type=style&index=0&id=2d2da57d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2da57d",
  null
  
)

export default component.exports